import React from "react";
import { TableCell, TableRow, makeStyles, useTheme } from "@material-ui/core";

import I18nText from "../../../elements/I18nText";
import FormattedDate from "../../../elements/FormattedDate";
import { FORMAT_DATE } from "../../../utils/formatting";
import {
  ListActionsWrapper,
  EditAction,
  DeleteAction
} from "../../../elements/ListAction";
import { MAINTENANCE_STATUS } from "../../../domain/maintenance";
import { useAuth, PERMISSIONS } from "../../../auth";

const useStyles = makeStyles(() => ({
  cell: {
    borderLeftWidth: 4,
    borderLeftStyle: "solid"
  }
}));

const statusColor = (theme, status) => {
  switch (status) {
    case MAINTENANCE_STATUS.DONE:
      return theme.palette.success.main;
    case MAINTENANCE_STATUS.OVERDUE:
      return theme.palette.error.main;
    case MAINTENANCE_STATUS.IN_PROGRESS:
      return theme.palette.info.main;
    case MAINTENANCE_STATUS.CANCELLED:
      return theme.palette.grey[300];
    case MAINTENANCE_STATUS.PENDING:
    default:
      return theme.palette.grey[500];
  }
};

const Row = React.memo(({ device, record, onEdit, onDelete }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { hasPermission } = useAuth();

  const canManage = hasPermission(device.permissions, PERMISSIONS.MAINTENANCE);

  return (
    <TableRow hover>
      <TableCell
        className={classes.cell}
        style={{ borderLeftColor: statusColor(theme, record.status) }}
      >
        {record.title}
      </TableCell>
      <TableCell>
        <I18nText>{`devices.maintenance.priorities.${record.priority}`}</I18nText>
      </TableCell>
      <TableCell>{record.technician}</TableCell>
      <TableCell>
        <FormattedDate format={FORMAT_DATE} fallback="-">
          {record.maintenanceAt}
        </FormattedDate>
      </TableCell>
      <TableCell align="right">{record.maintenanceInterval}</TableCell>
      <TableCell>
        <FormattedDate format={FORMAT_DATE} fallback="-">
          {record.nextDueAt}
        </FormattedDate>
      </TableCell>
      <TableCell>
        <I18nText>{`devices.maintenance.statuses.${record.status}`}</I18nText>
      </TableCell>
      <TableCell align="right">
        {canManage && (
          <ListActionsWrapper>
            <EditAction onClick={() => onEdit(record)} />
            <DeleteAction onClick={() => onDelete(record)} />
          </ListActionsWrapper>
        )}
      </TableCell>
    </TableRow>
  );
});

export default Row;
